<template>
    <div class="d-flex flex-column  position-relative">
        <template v-if="!disable && viewSwitchAble">
            <div class="d-flex flex-row">
                <layout-configuration-title
                    identify-code="em-filter-view-config"
                    :key-code="entityFilterKey"
                    @loadConfig="unpackConfig"></layout-configuration-title>
                <mini-button variant="outline-primary" class="thin ml-auto m-tb-auto" @btnClick="triggerFilterShow">
                    <i v-if="hideFilter" class="fa-solid fa-angles-down"></i>
                    <i v-else class="fa-solid fa-angles-up"></i>
                </mini-button>
            </div>
            <template v-if="hideFilter && currentFilter.length>0">
                <div class="d-flex flex-row flex-wrap">
                    <template v-for="(item,index) of currentFilter">
                        <div class="badge-card mt-1 mr-1 " :key="index">
                            {{ item.label }}: {{ item.value.label || item.value.value }}
                            <i class="fa-solid fa-xmark badge-x-icon" @click="clearFilter(item.key)"></i>
                        </div>
                    </template>
                </div>
            </template>
            <!--            <b-spinner v-show="queryLoading"-->
            <!--                       small variant="primary"-->
            <!--                       class="position-absolute right bottom"></b-spinner>-->
        </template>
        <div class="filters" :class="!disable && viewSwitchAble ? (hideFilter?'hide':'show') : ''">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import LayoutConfigurationTitle from "@/components/common/mini-table/cells/LayoutConfigurationTitle.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import filterViewSwitchMixin from "@/components/em/EmFilter/filter-view-switch-mixin";
import {_tryTranslateValueLabel} from "@/utils/em-model-value-translate";

export default {
    name: "FilterViewSwitch",
    mixins: [filterViewSwitchMixin],
    components: {MiniButton, LayoutConfigurationTitle},
    props: {
        filterFields: Array,
        entityFilterKey: String,
        disable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            hideFilter: false,
            currentFilter: []
        }
    },
    computed: {
        currentTableFilter() {
            return this.$parent.gatherConfig();
        },
        queryLoading() {
            return this.$parent.onSearching;
        },
    },
    watch: {
        currentTableFilter: {
            handler() {
                this.loadConfig();
            },
            deep: true,
        },
    },
    methods: {
        unpackConfig(item) {
            if (item == null) {
                this.$parent.doClear();
            } else {
                let fieldMap = {};
                for (let item of this.filterFields) {
                    fieldMap[item.key] = item;
                }
                let obj = JSON.parse(item.configuration);
                for (let key in obj) {
                    if (fieldMap.hasOwnProperty(key)) {
                        let value = obj[key];
                        if (value) {
                            let field = fieldMap[key];
                            let temp = _tryTranslateValueLabel(field, value);
                            this.setFilter(key, temp.value);
                        }
                    }
                }
                this.hideFilter = true;
            }
            this.$nextTick(() => this.$parent.doQuery());
        },
        setFilter(key, value) {
            this.$parent.$_emCustomVuexMixin_setFilterAttribute(key, value);
        },
        clearFilter(key) {
            this.$parent.$_emCustomVuexMixin_setFilterAttribute(key, '');
        },
        triggerFilterShow() {
            this.hideFilter = !this.hideFilter;
        },
        gatherConfig() {
            return this.currentTableFilter;
        },
        loadConfig(obj = this.currentTableFilter) {
            let tempArr = [];
            let fieldMap = {};
            for (let item of this.filterFields) {
                fieldMap[item.key] = item;
            }
            for (let key in obj) {
                if (fieldMap.hasOwnProperty(key)) {
                    let value = obj[key];
                    if (value) {
                        let field = fieldMap[key];
                        let temp = _tryTranslateValueLabel(field, value);
                        if (temp.needWaitEntityQuery) {
                            // this.needRetry = true;
                        }
                        tempArr.push({
                            key: key,
                            label: this.$t(field.label),
                            value: temp
                        })
                    }
                }
            }
            this.currentFilter = tempArr;
        },
        // $_trySomething() {
        //     this.loadConfig();
        // }
    }
}
</script>

<style scoped>
.filters {
    transition: max-height ease-in-out .4s;
}

.filters.show {
    max-height: calc(100vh);
}

.filters.hide {
    overflow: hidden;
    max-height: 0;
}

.thin {
    padding: .1rem .4rem !important;
    height: 1.5rem;
}

.badge-card {
    background-color: #f5f6f8;
    padding: .2rem .4rem;
    color: #75787f;
}

.badge-card:hover {
    background-color: #e6e8ed;
}

.badge-x-icon {
    cursor: pointer;
    margin: auto 0 auto .3rem;
    scale: 1.2;
}
</style>
